document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('pallisHeader');
  const button = document.getElementById('pallisMenuButton');
  const drawer = document.getElementById('pallisDrawer');
  const overlay = document.getElementById('pallisOverlay');

  const desktopMenus = document.querySelectorAll(
    '.pallis-desktop-nav details'
  );

  const accessTrigger = document.querySelector(
    '.pallis-private-access__trigger'
  );

  const accessModal = document.getElementById(
    'PallisPrivateAccessModal'
  );

  const accessBackdrop = document.querySelector(
    '.pallis-access-modal__backdrop'
  );

  const accessClose = document.querySelector(
    '.pallis-access-modal__close'
  );

  const accessInput = document.getElementById(
    'PallisPrivateAccessEmail'
  );

  if (!header) return;

  let lastScroll = window.scrollY || window.pageYOffset;
  let ticking = false;
  let lastFocusedElement = null;

  const desktopCloseTimers = new WeakMap();

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function showHeader() {
    header.classList.remove('is-hidden');
  }

  function hideHeader() {
    if (
      (!drawer || !drawer.classList.contains('is-open')) &&
      (!accessModal || !accessModal.classList.contains('is-open'))
    ) {
      header.classList.add('is-hidden');
    }
  }

  function openMenu() {
    if (!button || !drawer || !overlay) return;

    closeAccessModal(false);
    closeDesktopMenus();

    header.classList.add('menu-open');
    showHeader();

    drawer.classList.add('is-open');
    overlay.classList.add('is-open');

    document.body.classList.add('pallis-menu-lock');

    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('aria-label', 'Close menu');
  }

  function closeMenu(returnFocus) {
    if (!button || !drawer || !overlay) return;

    header.classList.remove('menu-open');

    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');

    document.body.classList.remove('pallis-menu-lock');

    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Open menu');

    if (returnFocus === true) {
      button.focus();
    }
  }

  function closeDesktopMenus(exceptMenu) {
    desktopMenus.forEach(function (menu) {
      if (menu !== exceptMenu) {
        const timer = desktopCloseTimers.get(menu);

        if (timer) {
          window.clearTimeout(timer);
          desktopCloseTimers.delete(menu);
        }

        menu.removeAttribute('open');
      }
    });
  }

  function openAccessModal() {
    if (!accessModal) return;

    lastFocusedElement = document.activeElement;

    closeMenu(false);
    closeDesktopMenus();

    accessModal.classList.add('is-open');
    accessModal.setAttribute('aria-hidden', 'false');

    document.body.classList.add('pallis-access-lock');

    if (accessTrigger) {
      accessTrigger.setAttribute('aria-expanded', 'true');
    }

    showHeader();

    window.setTimeout(function () {
      if (accessInput) {
        accessInput.focus();
      }
    }, 350);
  }

  function closeAccessModal(returnFocus) {
    if (!accessModal) return;

    accessModal.classList.remove('is-open');
    accessModal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('pallis-access-lock');

    if (accessTrigger) {
      accessTrigger.setAttribute('aria-expanded', 'false');
    }

    if (returnFocus === true) {
      if (lastFocusedElement instanceof HTMLElement) {
        lastFocusedElement.focus();
      } else if (accessTrigger) {
        accessTrigger.focus();
      }
    }
  }

  /*
   * Mobile drawer controls
   */
  if (button && drawer && overlay) {
    button.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeMenu(false);
      } else {
        openMenu();
      }
    });

    overlay.addEventListener('click', function () {
      closeMenu(false);
    });
  }

  /*
   * Private Access modal controls
   */
  if (accessTrigger) {
    accessTrigger.addEventListener('click', function () {
      openAccessModal();
    });
  }

  if (accessBackdrop) {
    accessBackdrop.addEventListener('click', function () {
      closeAccessModal(true);
    });
  }

  if (accessClose) {
    accessClose.addEventListener('click', function () {
      closeAccessModal(true);
    });
  }

  /*
   * Desktop dropdown hover behaviour
   */
  desktopMenus.forEach(function (menu) {
    const summary = menu.querySelector('summary');

    function cancelClose() {
      const timer = desktopCloseTimers.get(menu);

      if (timer) {
        window.clearTimeout(timer);
        desktopCloseTimers.delete(menu);
      }
    }

    function openDesktopMenu() {
      if (!isDesktop()) return;

      cancelClose();
      closeDesktopMenus(menu);
      menu.setAttribute('open', '');
    }

    function scheduleClose() {
      if (!isDesktop()) return;

      cancelClose();

      const timer = window.setTimeout(function () {
        menu.removeAttribute('open');
        desktopCloseTimers.delete(menu);
      }, 240);

      desktopCloseTimers.set(menu, timer);
    }

    menu.addEventListener('mouseenter', openDesktopMenu);
    menu.addEventListener('mouseleave', scheduleClose);

    if (summary) {
      summary.addEventListener('click', function (event) {
        if (isDesktop()) {
          event.preventDefault();
        }
      });
    }

    menu.addEventListener('focusin', openDesktopMenu);

    menu.addEventListener('focusout', function (event) {
      if (!isDesktop()) return;

      if (!menu.contains(event.relatedTarget)) {
        scheduleClose();
      }
    });
  });

  /*
   * Close desktop dropdowns when clicking elsewhere
   */
  document.addEventListener('click', function (event) {
    if (
      isDesktop() &&
      !event.target.closest('.pallis-desktop-nav')
    ) {
      closeDesktopMenus();
    }
  });

  /*
   * Escape closes menus and modal
   */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    if (
      accessModal &&
      accessModal.classList.contains('is-open')
    ) {
      closeAccessModal(true);
      return;
    }

    if (
      drawer &&
      drawer.classList.contains('is-open')
    ) {
      closeMenu(true);
      return;
    }

    closeDesktopMenus();
  });

  /*
   * Keep keyboard focus inside the modal
   */
  document.addEventListener('keydown', function (event) {
    if (
      event.key !== 'Tab' ||
      !accessModal ||
      !accessModal.classList.contains('is-open')
    ) {
      return;
    }

    const focusableElements = accessModal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), ' +
      'select:not([disabled]), textarea:not([disabled]), ' +
      'a[href], [tabindex]:not([tabindex="-1"])'
    );

    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[
      focusableElements.length - 1
    ];

    if (
      event.shiftKey &&
      document.activeElement === firstElement
    ) {
      event.preventDefault();
      lastElement.focus();
    } else if (
      !event.shiftKey &&
      document.activeElement === lastElement
    ) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  /*
   * Existing hide/show-on-scroll behaviour
   */
  function updateHeader() {
    const currentScroll = window.scrollY || window.pageYOffset;

    if (currentScroll <= 8) {
      header.classList.add('is-top');
      showHeader();
    } else {
      header.classList.remove('is-top');

      const drawerIsOpen =
        drawer && drawer.classList.contains('is-open');

      const accessModalIsOpen =
        accessModal &&
        accessModal.classList.contains('is-open');

      if (drawerIsOpen || accessModalIsOpen) {
        showHeader();
      } else if (
        currentScroll > lastScroll &&
        currentScroll > 70
      ) {
        hideHeader();
      } else if (currentScroll < lastScroll) {
        showHeader();
      }
    }

    lastScroll = Math.max(currentScroll, 0);
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    },
    { passive: true }
  );

  /*
   * Reset navigation when crossing breakpoints
   */
  window.addEventListener('resize', function () {
    if (isDesktop()) {
      closeMenu(false);
    } else {
      closeDesktopMenus();
    }
  });

  updateHeader();
});